import script from "./text-input.vue?vue&type=script&setup=true&lang=js"
export * from "./text-input.vue?vue&type=script&setup=true&lang=js"

import "./text-input.vue?vue&type=style&index=0&id=57b934b2&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b934b2"]])

export default __exports__